module.exports = [
  require('./tashalar'),
  require('./tethyr'),
  require('./thay'),
  require('./thesk'),
  require('./thindol'),
  require('./turmish'),
]
